import React, { useState, useEffect, useContext } from "react"
import { EstablishmentContext } from "../../Contexts/EstablishmentContext"
import { GeneralContext } from "../../Contexts/GeneralContext"

import Header from "../Header/Header"
import Footer from "../Footer/Footer"

import { HashLink } from 'react-router-hash-link'

import Content from "./MenuContent/Content"

import "./MenuList.css"

import {
    Switch,
    Route,
    Link,
    useHistory,
    useParams
} from "react-router-dom";


const MenuList = () => {

    // let { id } = useParams();

    const defineMenu = (menuID) => {
        handleSetGeneral({ ...general, selectedMenu: menuID })
    }

    const { general, handleSetGeneral } = useContext(GeneralContext)
    const { establishment, handleSetEstablishment } = useContext(EstablishmentContext)

    const scrollWidthOffset = (el) => {
        const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -80;
        window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
    }

    useEffect(() => {
        const header = document.getElementById("navbabar");
        if(header) {
            const sticky = header.offsetTop;
            const scrollCallBack = window.addEventListener("scroll", () => {
                if (window.pageYOffset > sticky) {
                    header.classList.add("sticky");
                } else {
                    header.classList.remove("sticky");
                }
            });
            return () => {
                window.removeEventListener("scroll", scrollCallBack);
            };
        }
    }, []);



    return (
        <>
            <Header esta={establishment}/>

            <div className="menu-list-content">

                {
                    establishment.menus !== null && establishment.menus.length > 1
                        ? <ul className="menu-horizontal" id="navbabar">
                            {establishment.menus.map((menu) => (
                                <li key={menu.id} className={menu.id === general.selectedMenu ? 'selected' : null} ><HashLink to={`/menus/${establishment.id}#${menu.id}`} scroll={el => scrollWidthOffset(el)} onClick={() => defineMenu(menu.id)}>{menu.name}</HashLink></li>
                            ))}
                        </ul>
                        : null
                }

                <Content />

                <Footer />

            </div>
        </>
    )
}

export default MenuList